import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["summary", "name"];

  connect() {
    this.show();
  }

  show() {
    const checked = this.element.querySelector("input[type='radio']:checked");
    const hiddenByFilter = checked && checked.closest("[hidden]") !== null;
    this.summaryTarget.hidden = !hiddenByFilter;
    this.nameTarget.textContent = hiddenByFilter ? checked.dataset.entryName : "";
  }
}
